//fetch all dashboard data from humpclub api
import { config } from '../../utils/config'

export async function getDashboardData(params?: {
  startDate?: string
  endDate?: string
  humpClubStoreCode?: string
  region?: string
  hotelGroupName?: string
  storeRepId?: string
  periodUnit?: string
  periodMode?: string
  token?: string | null
}) {
  const url = new URL(`${config.publicRuntimeConfig.humpclubRoot}/reporting/v2/dashboard-data`)

  if (params?.startDate) url.searchParams.set('startDate', params.startDate)
  if (params?.endDate) url.searchParams.set('endDate', params.endDate)
  if (params?.humpClubStoreCode) url.searchParams.set('humpClubStoreCode', params.humpClubStoreCode)
  if (params?.region) url.searchParams.set('region', params.region)
  if (params?.hotelGroupName) url.searchParams.set('hotelGroupName', params.hotelGroupName)
  if (params?.storeRepId) url.searchParams.set('storeRepId', params.storeRepId)
  if (params?.periodUnit) url.searchParams.set('periodUnit', params.periodUnit)
  if (params?.periodMode) url.searchParams.set('periodMode', params.periodMode)

  const response = await fetch(url.toString(), {
    headers: params?.token ? { Authorization: `Bearer ${params.token}` } : undefined,
  })
  if (!response.ok) {
    throw new Error(`Dashboard request failed (${response.status})`)
  }
  return response.json()
}
